<script lang="ts">
  import type { StyleValue } from 'vue'
  import { defineComponent, computed } from 'vue'
  import { getNamespace } from '../../../utils/global-config'
  import { addUnit } from '../../../shared/utils'

  export default defineComponent({
    name: 'BnIconAppCallUp',
    props: {
      size: {
        type: [Number, String],
        default: undefined
      },
      rotate: {
        type: Number,
        default: undefined
      },
      spin: {
        type: Boolean,
        default: false
      },
      color: {
        type: String,
        default: undefined
      }
    },
    setup(props) {
      const ns = getNamespace('icon')

      const styles = computed(() => {
        const styles: StyleValue = {}
        if (props.size) {
          styles.fontSize = addUnit(props.size)
        }

        if (props.rotate) {
          styles.transform = `rotate(${props.rotate}deg)`
        }

        if (props.color) {
          styles.color = props.color
        }
        return styles
      })

      const cls = computed(() => [
        ns,
        {
          [`${ns}-loading`]: props.spin
        }
      ])

      return {
        cls,
        styles
      }
    }
  })
</script>

<template>
  <i :class="cls" :style="styles">
    <svg
      width="44px"
      height="44px"
      viewBox="0 0 44 44"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>电话</title>
      <g id="CRM" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g
          id="线索管理-拨打电话"
          transform="translate(-1340.000000, -758.000000)"
          fill="#FFFFFF"
          fill-rule="nonzero"
        >
          <g id="编组-21" transform="translate(1316.000000, 737.000000)">
            <g id="电话" transform="translate(24.000000, 21.000000)">
              <path
                id="形状"
                d="M35.8447882,32.0216868 C36.6488441,32.8276514 36.6488441,34.1323549 35.8447882,34.9383195 L34.386343,36.3967648 C33.3086868,37.4744211 31.8912337,38.1308116 30.1731712,38.3481476 C29.7471123,38.4013936 29.3181219,38.4277427 28.8887494,38.427052 C27.6383588,38.427052 26.289226,38.2158898 24.8612026,37.7959132 C20.9849918,36.6566398 16.9082028,34.0872805 13.3851951,30.5632415 C9.86218738,27.0392025 7.29179681,22.9637027 6.15252341,19.087234 C5.58533591,17.1559606 5.39867969,15.3688045 5.60028905,13.7762966 C5.81762498,12.0582342 6.47401557,10.6407811 7.55167181,9.56312491 L9.01011711,8.10467961 C9.81608174,7.30062378 11.1207852,7.30062378 11.9267498,8.10467961 L18.3439606,14.5216326 C19.1480461,15.3276856 19.1480461,16.6324701 18.3439606,17.4385231 L16.8855153,18.8959371 C16.0605153,19.7209371 16.8816481,22.3923902 19.2189762,24.7294604 C21.5563042,27.0665307 24.2264683,27.8889525 25.0524995,27.0629213 L26.5109447,25.604476 C27.3169978,24.8003905 28.6217823,24.8003905 29.4278353,25.604476 L35.8447882,32.0216868 Z M25.2355463,17.0628903 C26.1464039,17.0638849 26.8845517,17.8020328 26.8855463,18.7128903 C26.8855463,19.1685252 27.2549114,19.5378903 27.7105463,19.5378903 C28.1661812,19.5378903 28.5355463,19.1685252 28.5355463,18.7128903 C28.533557,16.8911753 27.0572614,15.4148796 25.2355463,15.4128903 C24.7799114,15.4128903 24.4105464,15.7822554 24.4105464,16.2378903 C24.4105464,16.6935252 24.7799114,17.0628903 25.2355463,17.0628903 L25.2355463,17.0628903 Z M37.3978507,13.5746873 C35.334639,8.68546637 30.5422692,5.50883885 25.2355463,5.51288674 C24.7799114,5.51288674 24.4105464,5.88225569 24.4105464,6.3378906 C24.4105464,6.79352551 24.7799114,7.16289058 25.2355463,7.16289058 C31.6035149,7.16289058 36.785546,12.3449217 36.785546,18.7128903 C36.785546,19.1685252 37.1549111,19.5378903 37.610546,19.5378903 C38.0661809,19.5378903 38.43557,19.1685252 38.43557,18.7128903 C38.4389222,16.9477785 38.0859758,15.2001457 37.3978507,13.5746873 L37.3978507,13.5746873 Z M25.2355463,12.1128904 C28.8748275,12.1128904 31.8355462,15.0736091 31.8355462,18.7128903 C31.8355462,19.1685252 32.2049113,19.5378903 32.6605462,19.5378903 C33.1161811,19.5378903 33.4855461,19.1685252 33.4855461,18.7128903 C33.4855461,16.5248543 32.6163522,14.4264346 31.0691772,12.8792595 C29.5220021,11.3320844 27.4235823,10.4628905 25.2355463,10.4628905 C24.7799114,10.4628905 24.4105464,10.8322556 24.4105464,11.2878905 C24.4105464,11.7435254 24.7799114,12.1128904 25.2355463,12.1128904 L25.2355463,12.1128904 Z"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </i>
</template>
